module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-template-list"
  }, [_vm._l((_vm.reportTemplates), function(template) {
    return _c('report-template', {
      key: "id",
      attrs: {
        "template": template,
        "isEditing": !template.id
      }
    })
  }), _c('footer', [_c('div', {
    staticClass: "actions"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.addNewTemplate.apply(null, arguments)
      }
    }
  }, [_vm._v("Add Template")])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3627bb08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report-template-list.vue
// module id = 262
// module chunks = 1